// ─── Two sources, runtime wins over build time: ───────────────────────────────
//   window.__CONFIG__      runtime — injected by entrypoint.sh at container start (no rebuild)
//   import.meta.env.VITE_* build time — baked from .env file (local dev fallback)
declare const __DD_VERSION__: string | undefined;

interface DdRuntimeConfig {
  VITE_DD_ENABLED?:              string;
  VITE_DD_USE_MOCK?:             string;
  VITE_DD_APP_ID?:               string;
  VITE_DD_CLIENT_TOKEN?:         string;
  VITE_DD_SITE?:                 string;
  VITE_DD_SERVICE?:              string;
  VITE_DD_REPLAY_SAMPLE_RATE?:   string;
  VITE_DD_TRACE_SAMPLE_RATE?:    string;
  VITE_DD_TENANT?:               string;
  VITE_DD_RIS_FLAVOR?:           string;
  VITE_APP_ENV?:                 string;
}

const runtimeConfig = (window as unknown as { __CONFIG__?: DdRuntimeConfig }).__CONFIG__ ?? {};

const parseRate = (raw: string | undefined, fallback: number): number => {
  const n = Number(raw);
  return raw !== undefined && raw !== '' && !Number.isNaN(n) ? Math.min(100, Math.max(0, n)) : fallback;
};

export const ddConfig = {
  enabled:           (runtimeConfig.VITE_DD_ENABLED     ?? import.meta.env.VITE_DD_ENABLED)     === 'true',
  clientToken:        runtimeConfig.VITE_DD_CLIENT_TOKEN ?? import.meta.env.VITE_DD_CLIENT_TOKEN,
  appId:              runtimeConfig.VITE_DD_APP_ID       ?? import.meta.env.VITE_DD_APP_ID,
  site:               runtimeConfig.VITE_DD_SITE         ?? import.meta.env.VITE_DD_SITE,
  service:            runtimeConfig.VITE_DD_SERVICE      ?? import.meta.env.VITE_DD_SERVICE,
  replaySampleRate:   parseRate(runtimeConfig.VITE_DD_REPLAY_SAMPLE_RATE ?? import.meta.env.VITE_DD_REPLAY_SAMPLE_RATE, 20),
  traceSampleRate:    parseRate(runtimeConfig.VITE_DD_TRACE_SAMPLE_RATE  ?? import.meta.env.VITE_DD_TRACE_SAMPLE_RATE,  20),
  tenant:             runtimeConfig.VITE_DD_TENANT       ?? import.meta.env.VITE_DD_TENANT,
  risFlavor:          runtimeConfig.VITE_DD_RIS_FLAVOR   ?? import.meta.env.VITE_DD_RIS_FLAVOR,
  env:                runtimeConfig.VITE_APP_ENV         ?? import.meta.env.VITE_APP_ENV         ?? 'development',
  useMock:            (runtimeConfig.VITE_DD_USE_MOCK     ?? import.meta.env.VITE_DD_USE_MOCK)    === 'true',
  version:            __DD_VERSION__,
} as const;
